export default __webpack_public_path__ + "static/changingtheworld-6cb3c43dc66c2aab8386363cedfb3d49.png";